import { HighRiskRecipients } from '@Dashboard/Charts/HighRiskRecipients';
import { useColorMode, useColorStyle, Box } from '@tonic-one/react';
import { useTranslation } from 'react-i18next';

const HighRiskRecipientsChart = (props: { insightsData: any; day: string }) => {
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  const { t } = useTranslation();

  return (
    <Box>
      <Box
        mb="24px"
        fontSize="18px"
        fontWeight="600"
        lineHeight="24px"
        color={colorStyle.color.primary}
      >
        {t('riskUser.maliciousReceived')}
      </Box>
      <HighRiskRecipients
        data={props.insightsData?.RiskyRecipientsDistribution?.[props.day]}
        interval={props.day}
      />
    </Box>
  );
};

export default HighRiskRecipientsChart;
